import { apiClient, handleApiRequest } from './client'

export interface EmailTestSessionChoice {
  session_id: string
  period: string
  anfrage_count: number
}

export interface EmailTestRollbackState {
  visible: boolean
  label: string
  choice?: 'nothing' | 'confirm' | 'dismissed' | 'done' | 'picker' | 'rejected'
  picker?: boolean
  message?: string | null
  session_id?: string | null
  anfrage_count?: number
  sessions?: EmailTestSessionChoice[]
  changed?: boolean
  cancelled?: number
}

export const emailTestApi = {
  preview: () =>
    handleApiRequest<EmailTestRollbackState>(apiClient.get('/api/v1/email-test/rollback')),

  apply: (confirm: boolean, sessionId?: string | null) =>
    handleApiRequest<EmailTestRollbackState>(
      apiClient.post('/api/v1/email-test/rollback', {
        confirm,
        session_id: sessionId ?? null,
      }),
    ),
}
